import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import { fidelizacao_seg_rede } from "../../services/api";

import { ConverteSerie, ConverteSegmentoSig, ordem } from "./modulo";

import './detalhamento_bolsa.css';

const Fidelizacao_seg_rede = (props) => {

    const [data2, setData2] = useState([]);

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes']


    let data_inicio = props.di;
    let data_fim = props.df;

    const fetchData = async () => {
        try {
            const response = await fidelizacao_seg_rede(data_inicio, data_fim);
            setData2(response);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        console.log("B")
        fetchData();
    }, [data_inicio, data_fim]);

    let TotalPR = 0; // total de possibilidade de renovação
    let TotalRN = 0; // Total de renovados
    let TotalEV = 0; // Total Evasão

    let chartDatSerie = [];

    if (typeof data2 !== 'undefined') {
        chartDatSerie = data2.map((item, index) => {
            const row = [ordem(item.segmento)];
            row.push(item.segmento);
            row.push(parseInt(item.pr));
            TotalPR = TotalPR + (parseInt(item.pr));
            row.push(parseInt(item.pr) - parseInt(item.evasao));
            TotalRN = TotalRN + ((parseInt(item.pr) - parseInt(item.evasao)));
            TotalEV = TotalEV + (parseInt(item.evasao));
            row.push(100 - (parseFloat(item.evasao) * 100) / parseFloat(item.pr))
            row.push((parseFloat(item.evasao) * 100) / parseFloat(item.pr));
            return row;
        });
    };

    chartDatSerie.sort();

    chartDatSerie.unshift(["#", "2024", "P.Renovação", "Renovados", "RENOVAÇÃO", "EVASÃO"]);

    let TotalRNP = (100 - (parseFloat(TotalEV) * 100) / parseFloat(TotalPR)); // total de Renovação percentual
    let TotalEVP = ((parseFloat(TotalEV) * 100) / parseFloat(TotalPR)); // total de Renovação percentual

    chartDatSerie.push(["", "TOTAL", TotalPR, TotalRN, TotalRNP, TotalEVP]);

    const options = {
        allowHtml: true,

    };

    const formatters = [
        {
            type: "NumberFormat",
            column: 4,
            options: {
                suffix: "%",
            },
        },
        {
            type: "BarFormat",
            column: 4,
            options: {
                width: 80,
                base: 0,
                max: 100,
                min: 0,
            },
        },
        {
            type: "NumberFormat",
            column: 5,
            options: {
                suffix: "%",
            },
        },
        {
            type: "ColorFormat",
            column: 5,
            ranges: [
                [0, 25, "white", "green"],
                [25, 40, "white", "orange"],
                [40, 50, "white", "red"],
                [50, 75, "white", "darkred"],
                [75, 100, "white", "black"],
            ],
        },

    ];




    return (
        <div className="Evasão">
            <Chart
                chartType="Table"
                version="current"
                width="100%"
                data={chartDatSerie}
                options={options}
                formatters={formatters}
            />
        </div>
    );
};
export default Fidelizacao_seg_rede;